import React, { useContext, useState } from "react";
import { Eyebrow } from "@bloomberg/media-ui-article";
import { TerminalTout } from "@bloomberg/media-ui-core";
import { ViewportElement } from "@foundation/viewport-element";
import styles from "./leftRail.module.css";
import { QuoteContext } from "~context/QuoteContext";
import QuoteSearch from "~components/QuoteSearch";
import Share from "~components/Share";
import YourWatchlist from "~components/YourWatchlist";
import Placeholder from "~components/Placeholder";
import { SecurityList } from "~components/dynamic";
import { useLocale } from "~hooks/i18n/useLocale";
import { useTranslateMessage } from "~utils/i18n";

export const LeftRail = () => {
  const quoteData = useContext(QuoteContext);
  const [enteredSecurityList, setEnteredSecurityList] = useState(false);
  const [securityListDataLoaded, setSecurityListDataLoaded] = useState(false);
  const { isJapanese, locale } = useLocale();

  const { searchClientURL, countryCode } = quoteData || {};
  const translateMessage = useTranslateMessage();

  if (!quoteData) {
    return null;
  }

  const marketLabel = translateMessage({
    id: "markets",
    defaultMessage: "Markets",
  });

  const dataLabel = translateMessage({
    id: "data",
    defaultMessage: "Data",
  });

  const sectionTitleLink = locale === "ja" ? "/jp/markets" : "/markets";

  return (
    <>
      <div className={styles.leftRail}>
        <Eyebrow
          sectionTitle={marketLabel}
          subsectionTitle={dataLabel}
          sectionTitleLink={sectionTitleLink}
        />

        <QuoteSearch
          searchURL={searchClientURL || ""}
          countryCode={countryCode}
        />

        <div className={styles.securityListContainer}>
          <ViewportElement
            onEnter={() => setEnteredSecurityList(true)}
            rootMargin="400px"
          >
            {(!enteredSecurityList || !securityListDataLoaded) && (
              <Placeholder
                width="194px"
                height="282px"
                className={styles.securityListPlaceholder}
              />
            )}
            {enteredSecurityList && (
              <SecurityList onLoad={() => setSecurityListDataLoaded(true)} />
            )}
          </ViewportElement>
        </div>
        <Share className={styles.share} />
        <TerminalTout className={styles.terminalTout} />
        {!isJapanese && <YourWatchlist />}
      </div>

      <div className={styles.leftRailSmallDesktop}>
        <Share className={styles.share} vertical />
      </div>
    </>
  );
};
